import React from 'react';
import PropTypes from 'prop-types';

import SelectableRow from 'components/selectable_record_table/selectable_row';
import PersonActions from './person_actions';
import Cell from './person_cell';

export default function PersonRow({
  cellOverrides,
  columns,
  person,
  onRemoveContact,
  onUpdateContact
}) {
  const actionsDropdown = <PersonActions person={person} onDelete={onRemoveContact} onEdit={onUpdateContact} />;
  const renderedColumns = columns.map((columnName) => {
    if (cellOverrides && cellOverrides[columnName]) {
      const OverrideComponent = cellOverrides[columnName];
      return <td key={columnName}><OverrideComponent contactPerson={person} /></td>;
    }

    return <Cell columnName={columnName} contactPerson={person} key={columnName} />;
  });

  return (
    <SelectableRow hideCheckbox={true}>
      {renderedColumns}
      <td>{actionsDropdown}</td>
    </SelectableRow>
  );
}

PersonRow.propTypes = {
  cellOverrides: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  person: PropTypes.object.isRequired,
  onRemoveContact: PropTypes.func.isRequired,
  onUpdateContact: PropTypes.func.isRequired
};
